
function loginCustomer(email, password) {
  return fetch('/account/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: new URLSearchParams({
      'customer[email]': email,
      'customer[password]': password
    })
  })
  .then(response => {
    if (response.ok) {
    	alert('Logged in')

      window.location.reload();
    } else {

      console.error('Login failed');
    }
  });
}


function registerCustomer(email, password, firstName = '', lastName = '') {
  return fetch('/account', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: new URLSearchParams({
      'customer[email]': email,
      'customer[password]': password,
      'customer[first_name]': firstName,
      'customer[last_name]': lastName
    })
  })
  .then(response => {
    if (response.ok) {
    	alert('Registered')
      window.location.reload(); // Redirect or show a success message
    } else {
      console.error('Registration failed');
    }
  });
}
